var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template"},[_c('img',{attrs:{"src":_vm.getTemplateSrc(_vm.photo.templateCode)}}),_c('div',{staticClass:"template-photo"},[_c('img',{attrs:{"src":_vm.getImageUrl(_vm.photo.photoUri)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }